import { NavLink } from "react-router-dom";
import "./Menu.css";

export default function Menu() {
  return (
    <header className="menu-bar">
      <NavLink
        to="/home"
        className="menu-brand"
        aria-label="Accueil pdf-convert.fr"
      >
        <img src="/logo192.png" alt="pdf-convert.fr" className="menu-logo" />
      </NavLink>

      <nav className="menu-links" aria-label="Navigation principale">
        <NavLink
          to="/conversion"
          className={({ isActive }) =>
            isActive ? "menu-link active" : "menu-link"
          }
        >
          Conversion PDF-JPG
        </NavLink>

        <NavLink
          to="/fusion"
          className={({ isActive }) =>
            isActive ? "menu-link active" : "menu-link"
          }
        >
          Fusion PDF
        </NavLink>

        <NavLink
          to="/reduction"
          className={({ isActive }) =>
            isActive ? "menu-link active" : "menu-link"
          }
        >
          Réduction taille d’image
        </NavLink>

        <NavLink
          to="/sign-pdf"
          className={({ isActive }) =>
            isActive ? "menu-link active" : "menu-link"
          }
        >
          Signer/Annoter PDF
        </NavLink>
      </nav>
    </header>
  );
}
